window.Findation = window.Findation || {};

class FindationWidget extends HTMLElement {
  constructor() {
      super();
      this.debugEnabled = false;
      this.src = this.dataset.src;
      this.apiKey = this.dataset.apiKey;
      if (this.debugEnabled) {
        console.log('FINDATION | In Findation Element Constructor');
      }
      
      this.components = {
        openButton: this.querySelector('a'),
        iFrameButton: this.querySelector('span.findation-button')
      };
      this.state = {
        initCalled: false
      };
      this.isOpen = false;
      this.variantMetafieldsByBarcode = null;
  }
  
  connectedCallback() {
      this.loadFindationScript();
  }

  loadFindationScript() {
    if (!this.isFindationLoaded()) {
      const script = document.createElement('script');
      script.src = this.src;
      script.async = true;

      script.onload = () => {
        this.attachEventListeners();
        this.findationLoaded();
      };

      script.onerror = () => {
        console.error(`Failed to load ${this.src}`);
      };
      document.body.appendChild(script);
    } else {
      this.attachEventListeners();
      this.findationLoaded();
    }
  }

  getWidget() {
    return window.Findation;
  }

  isFindationLoaded() {
    return window.Findation && window.Findation.init && typeof window.Findation.init === 'function';
  }

  getVariantMetafieldsByBarcode() {
    if (this.variantMetafieldsByBarcode) {
      return this.variantMetafieldsByBarcode;
    }

    const jsonEl = this.querySelector('.findation-variant-metafields');
    if (jsonEl?.textContent) {
      try {
        const parsed = JSON.parse(jsonEl.textContent);
        this.variantMetafieldsByBarcode = Array.isArray(parsed)
          ? parsed.reduce((acc, item) => {
              if (item?.barcode) {
                acc[item.barcode] = item;
              }
              return acc;
            }, {})
          : {};
      } catch (error) {
        console.error('Findation: failed to parse variant metafields JSON', error);
        this.variantMetafieldsByBarcode = {};
      }
    }

    if (!this.variantMetafieldsByBarcode) {
      this.variantMetafieldsByBarcode = window.findatonVariantMetafieldsByBarcode || {};
    }

    return this.variantMetafieldsByBarcode;
  }

  getProductContainer() {
    const productInfo = this.closest('product-info');
    if (productInfo) {
      return productInfo.querySelector('.main-product-data');
    }

    const modalProductInfo = this.closest('#VtoModal, #findMyShadeModal')?.querySelector('product-info');
    if (modalProductInfo) {
      return modalProductInfo.querySelector('.main-product-data');
    }

    return document.querySelector('.product-section product-info[data-view-context="PDP"] .main-product-data')
      || document.querySelector('.main-product-data');
  }

  getCartContext() {
    if (this.closest('#Quickshop-Modal, #Quickshop-Modal-cart, #Buildkit-Quickshop-Modal, #CustomKit-Quickshop-Modal')) {
      return 'quickview';
    }

    return null;
  }

  getQuickviewModal() {
    return this.closest('#Quickshop-Modal, #Quickshop-Modal-cart, #Buildkit-Quickshop-Modal, #CustomKit-Quickshop-Modal');
  }

  shouldResetStateOnOpen() {
    return Boolean(this.getQuickviewModal() || this.closest('#findMyShadeModal'));
  }

  resetWidgetState() {
    const startOverButton = document.querySelector('.findation-component .start-over');
    if (startOverButton instanceof HTMLElement) {
      startOverButton.click();
    }
  }

  findationLoaded() {
    if (this.debugEnabled) {
      console.log('FINDATION | Findation:loaded - InitCalled: %O', this.state.initCalled);
    }
    if (this.state.initCalled === false && this.isFindationLoaded() && this.apiKey) {
      // the goal is to have it assigned on the HTMLElement, currently its hard-coded, not sure long term solution for this, as we don't seem to have productID
      let productID = this.getAttribute('data-product-id'); // findationLauncher.getAttribute('data-findation-product');
      if (this.debugEnabled) {
        console.log("FINDATION | Findation:loaded ProductID: %s", productID);
      }
      
      if (productID) {
        window.Findation.init(
          this.components.iFrameButton, 
          this.apiKey,
          {
            productId: productID,
            buttonWidth: '0px',
            buttonHeight: '0px' 
          }
        );
        // update the state
        this.state.initCalled = true;
      }
      
      // Update classes based on selected shade
      // TODO: This is from the SFCC code base it fires whenever an variation attribute is selected,  need to come up with an equivalent.
      document.body.addEventListener('product:afterAttributeSelect', () => {
        if (this.debugEnabled) {
          console.log('FINDATION | product:afterAttributeSelect');
        }
        const findationResults = document.querySelector('.findation-component .findation-results');
        const selectedShadeId = document.querySelector('.attribute button.color-attribute.selected:not(#mobileAttributesDrawer .attribute button.color-attribute.selected)').dataset.productid;
        const matchedShadeId = findationResults.querySelector('.matched-shade-info .color-attribute').dataset.productid;
        
        if (selectedShadeId === matchedShadeId) {
          findationResults.classList.remove('matched-shade-not-selected');
        } else {
          findationResults.classList.add('matched-shade-not-selected');
        }
      });

      // Handle swatch and shade name clicks
      // TODO: Not sure if this is the best way to structure this
      document.body.addEventListener('click', (e) => {
        if (e.target.matches('.findation-component .matched-shade-info .color-attribute, .findation-component .matched-shade-info .shade-name')) {
          if (this.debugEnabled) {
            console.log('FINDATION | click:event');
          }
          e.preventDefault();
          const target = e.target;
          if (target.closest('.matched-shade-not-selected')) {
            const matchedShadeId = target.dataset.productid;
            const swatch = document.querySelector(`.attribute button.color-attribute[data-productid="${matchedShadeId}"]:not(#mobileAttributesDrawer .attribute button.color-attribute)`);
            swatch.click();
          }
        }
      });
    }
  }

  wireUpAnalytics() {
    window.Findation.widgetDidOpen = () => {
      // Add analytics code here
      this.isOpen = true;
    };
    window.Findation.widgetDidClose = () => {
      this.isOpen = false;
      document.body.classList.remove('scroll-lock');
      if (this.shouldResetStateOnOpen()) {
        window.setTimeout(() => this.resetWidgetState(), 0);
      }
    };
    window.Findation.widgetEmbedded = function() {
      const findationBtn = document.querySelector('.findation-btn.disabled');
      if (findationBtn) {
        findationBtn.classList.remove('disabled');
        findationBtn.removeAttribute('disabled');
      }
    };
  }

  searchComplete() {
    window.Findation.onSearchComplete = (data) => {
      if (data.matchSuccess) {
        // Handle search completion
      }
    };
  }

  actionReceived() {
    window.Findation.onActionReceived = async (payload) => {
      document.body.classList.remove('scroll-lock');
      let payloadObj = typeof payload === 'string' ? JSON.parse(payload) : payload;
      if (this.debugEnabled) {
        console.log('Findation: Payload - %O', payloadObj);
      }
      if (payloadObj && payloadObj.externalID) {
        switch (payloadObj.trigger) {
          // shade will only updated after user interaction
          case 'shop-the-shade':
            shadeMatch.selectShadeByTitle();
            break;
          case 'add-to-bag': {
            shadeMatch.selectShadeByTitle();
            const customKitSingleContext = this.getCustomKitContext();
            if (customKitSingleContext && payloadObj.id) {
              document.dispatchEvent(new CustomEvent('custom-kit:add-item-from-vto', {
                detail: {
                  productId: customKitSingleContext.productId,
                  variantId: Number(payloadObj.id),
                  collectionId: customKitSingleContext.collectionId
                }
              }));
              this.handleAddToCartClick();
              break;
            }

            const productData = this.getProductContainer();

            try {
              const shouldBlock = await window.preventAddIfMaxedOut(payloadObj.id, productData);
              if (shouldBlock) {
                this.handleAddToCartClick();
                break;
              }

              await window.addToCartBySku(payloadObj.id, this.getCartContext());
              this.handleAddToCartClick();
            } catch (e) {
              if (this.debugEnabled) {
                console.log('There was an error adding to cart %s', e);
              }
            }
            
            break;
          }
          case 'vto':
            try {
              var fetchModalOpener_BTN = document.querySelector('#findMyShadeModal fetch-modal-opener[data-modal="#VtoModal"] button');
              if (fetchModalOpener_BTN) {
                // add data attribute for back button context
                fetchModalOpener_BTN.setAttribute('data-back-button-context', 'findation-widget');
                if (this.debugEnabled) {
                  console.log("Findation: VTO Opener Btn: %o", fetchModalOpener_BTN);  
                }
                fetchModalOpener_BTN.click();  
              } else {
                if (this.debugEnabled) {
                  console.log('Couldn\'t Find: fetch-modal-opener[data-modal="#VtoModal"] button');
                }
              }
            } catch (e) {
              if (this.debugEnabled) {
                console.log('There was an error launching VTO: %O', e);
              }
            }
            break;
        }      
      }
    };
  }
  /**
   * This function sends back from Findation to us the markup it's going to use to display the results. 
   *    The HTML it returns is defined in Findation admin for the widget, section: Successful Result text
   *    We can then modify the html that gets passed and add anything we want or need to.  Minimally we need to do the following
   *      - Pass the shade swatch URL
   *      - Add the shade description - as Findation is only aware of the shade name, ie: 12N Fair Neutral, we need to also pull in the description 
   *          which is something like: "fair skin with a balance of warm & cool undertones"
   *      - update the click button to send data back to us so we can update the selected shade, and select the appropriate swatch
   *      
   */
  renderResults() {
    window.Findation.resultsWillRender = (html) => {
      let returnHTML = html;
      if (html) {
        const parser = new DOMParser();
        const results = parser.parseFromString(html, 'text/html').body;
        const variantID = results.querySelector('input[name="externalID"]') ? results.querySelector('input[name="externalID"]').value : null;
        const shadeName = results.querySelector('input[name="shadeName"]') ? results.querySelector('input[name="shadeName"]').value : null;

        if (variantID) { 
          const shadeMatchDetail = {
            handle: this.dataset.handle,
            barcode: variantID, // the externalID is shopify product.barcode
            featureID: 'findation'
          };
          document.body.dispatchEvent(new CustomEvent('shadeMatch:setData', { detail : shadeMatchDetail }));

          // const barcode = String(recent.barcode);
          const variantData = this.getVariantMetafieldsByBarcode()?.[variantID];
          if (!variantData) {
            return;
          }
          const { id: id, shade_swatch: swatchUrl, title: shadeName } = variantData;
          results.querySelector('.swatch-inner').style.backgroundImage = `url(${swatchUrl})`;
          
          const sendWidgetObject = {
            externalID: variantID,
            id: id,
            shadeName: shadeName,
            imageURL: swatchUrl,
            trigger: "shop-the-shade",
            pdpURL: 'pdpURL' // what was the PDP URL for? - oh maybe for trigging the shope this shade not sure if we still have that functionality
            
          };
          const shopButton = results.querySelector('button.shop-this-shade');
          if (shopButton) {
            shopButton.setAttribute('onclick', `sendWidgetAction(${JSON.stringify(sendWidgetObject)});document.querySelector('a.close').click();`);
          }

          sendWidgetObject.trigger = 'add-to-bag';
          // update the add to cart button as well
          const addToCardButton = results.querySelector('button.add-to-bag');
          if (addToCardButton) {
            addToCardButton.setAttribute('onclick', `sendWidgetAction(${JSON.stringify(sendWidgetObject)});document.querySelector('a.close').click();`);
            const customKitSingleContext = this.getCustomKitContext();
            if (customKitSingleContext) {
              addToCardButton.textContent = 'ADD TO KIT';
            }
          }
          
          sendWidgetObject.trigger = 'vto';
          // update the vto
          const vtoLink = results.querySelector('.vto-cta a');
          if (vtoLink) {
            vtoLink.setAttribute('onclick', `sendWidgetAction(${JSON.stringify(sendWidgetObject)});document.querySelector('a.close').click();`);
          }
          
          returnHTML = results.innerHTML;
        }
      }
      return returnHTML;
    };
  }

  openWidget() {
    if (window.Findation) {
      const openedFromQuickview = this.getQuickviewModal();

      // Quickview clears its contents on close, so keep it mounted while the Findation overlay opens.
      if (!openedFromQuickview) {
        window.closeAllModalDialogs();
      }
      if (this.shouldResetStateOnOpen()) {
        this.resetWidgetState();
      }
      document.body.classList.add('scroll-lock');
      window.Findation.openWidget();
      if (this.shouldResetStateOnOpen()) {
        window.requestAnimationFrame(() => this.resetWidgetState());
      }
    }
  }

  handleAddToCartClick() {
    const quickviewModal = this.getQuickviewModal();
    if (quickviewModal?.hide) {
      quickviewModal.hide();
      return;
    }

    const findMyShadeModal = document.querySelector('#findMyShadeModal');
    if (findMyShadeModal) {
      findMyShadeModal.hide();
    }
  }
  

  attachEventListeners() {
    this.findationLoaded();
    this.wireUpAnalytics();
    this.searchComplete();
    this.actionReceived();
    this.renderResults();
    this.components.openButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.openWidget();
    });
  }

  getCustomKitContext() {
    const productId = Number(this.getAttribute('data-product-id'));
    if (!productId || Number.isNaN(productId)) {
      return null;
    }

    const customKitEl = document.querySelector('custom-kit');
    if (!customKitEl) {
      return null;
    }

    let collectionId = null;
    if (typeof customKitEl.findProductAndCollectionByProductId === 'function') {
      const { collection } = customKitEl.findProductAndCollectionByProductId(productId) || {};
      if (collection?.id) {
        collectionId = Number(collection.id);
      }
    } else if (Array.isArray(customKitEl.collections)) {
      const collection = customKitEl.collections.find(col =>
        Array.isArray(col.products) && col.products.some(p => Number(p.id) === productId)
      );
      if (collection?.id) {
        collectionId = Number(collection.id);
      }
    }

    return { customKitEl, productId, collectionId };
  }

  appendToUrl(url, params) {
    // Add utility function to append parameters to a URL
    const urlObj = new URL(url);
    Object.keys(params).forEach(key => urlObj.searchParams.append(key, params[key]));
    return urlObj.toString();
  }
}

// Define the custom element
customElements.define('findation-widget', FindationWidget);
